import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  filters: {
    formatDate(value: any) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
      }
      return '';
    }
  }
})
export default class FormsMixin extends Vue {
  /* Variables */
  protected valid = false;
  protected verPassword = false;
  protected btnLoading = false;
  protected alertError = "";

  /* Array y objetos */
  protected tipos: object = [
    { nombre: "formsmixin.tipos.usuario", valor: "usuario" },
    { nombre: "formsmixin.tipos.email", valor: "correo" },
    { nombre: "formsmixin.tipos.telefono", valor: "telefono" },
    { nombre: "formsmixin.tipos.password", valor: "password" },
    { nombre: "formsmixin.tipos.hash", valor: "hash" },
  ];

  /* Reglas */
  protected countMinUsuario = 3;
  protected countMaxUsuario = 10;
  protected rulesUsuario: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
    (v: any) =>
      (v && v.length >= this.countMinUsuario) || "formsmixin.rules.min",
    (v: any) =>
      (v && v.length <= this.countMaxUsuario) || "formsmixin.rules.max",
  ];
  protected countMinPassword = 4;
  protected countMaxPassword = 10;
  protected rulesPassword: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
    (v: any) =>
      (v && v.length >= this.countMinPassword) || "formsmixin.rules.min",
    (v: any) =>
      (v && v.length <= this.countMaxPassword) || "formsmixin.rules.max",
  ];
  protected rulesEmail: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
    (v: any) => (!!v && this.emailIsValid(v)) || "formsmixin.rules.emailvalido",
  ];
  protected countMinTermino = 3;
  protected countMaxTermino = 64;
  protected rulesTermino: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
    (v: any) =>
      (v && v.length >= this.countMinTermino) || "formsmixin.rules.min",
    (v: any) =>
      (v && v.length <= this.countMaxTermino) || "formsmixin.rules.max",
  ];
  protected rulesTipo: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
  ];
  protected countMinObservaciones = 0;
  protected countMaxObservaciones = 100;
  public rulesObservaciones: object = [
    (v: any) => !!v || "formsmixin.rules.obligatorio",
    (v: any) =>
      (v && v.length >= this.countMinObservaciones) || "formsmixin.rules.min",
    (v: any) =>
      (v && v.length <= this.countMaxObservaciones) || "formsmixin.rules.max",
  ];
  

  /* Funciones */
  protected emailIsValid(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  formatDateES(data: string) {
    return moment(data).format("DD/MM/YYYY");
  }

  formatDateEN(data: string) {
    return moment(data, "DD/MM/YYYY").format("YYYY-MM-DD");
  }

  public fechaFormateada(fecha: string) {
    try {
      const [year, month, day] = fecha.substr(0, 10).split("-");
      return `${day}-${month}-${year}`;
    } catch (error) {
      return "-";      
    }
  }

  
  public fechaFormateadaSQLtoJS(fecha: string) {
    const [year, month, day] = fecha.substr(0, 10).split("-");

    return `${year}-${month}-${day}`;
  }

  public formatPrice(value: number) {
    const val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "€";
  }

  public formatNumber(value: number) {
    const val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  public formatPricePesoUnidad(value: number, tipo: string) {
    const formato = tipo!="U" ? "€/Kg" : "€/U";
    const val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + formato;
  }
}
